import React, { useEffect, useRef, useState } from 'react';

const CountUp = ({ end, duration = 2000, prefix = '', suffix = '' }) => {
  const [count, setCount] = useState(0);
  const countRef = useRef(null);
  const observerRef = useRef(null);

  useEffect(() => {
    observerRef.current = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && count === 0) {
          const startTime = Date.now();
          const startValue = 0;
          const endValue = parseInt(end.replace(/\D/g, ''));

          const animate = () => {
            const now = Date.now();
            const progress = Math.min((now - startTime) / duration, 1);
            
            // Easing function для плавности
            const easeOutQuart = 1 - Math.pow(1 - progress, 4);
            const current = Math.floor(startValue + (endValue - startValue) * easeOutQuart);
            
            setCount(current);

            if (progress < 1) {
              requestAnimationFrame(animate);
            } else {
              setCount(endValue);
            }
          };

          animate();
          observerRef.current.disconnect();
        }
      },
      { threshold: 0.5 }
    );

    if (countRef.current) {
      observerRef.current.observe(countRef.current);
    }

    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, [end, duration, count]);

  const displayValue = end.includes('+') 
    ? `${prefix}${count.toLocaleString()}+${suffix}`
    : `${prefix}${count.toLocaleString()}${suffix}`;

  return <span ref={countRef}>{displayValue}</span>;
};

export default CountUp;

